module.exports = __webpack_public_path__ + "static/media/YM16_5.1ff16697.jpg";